/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { openBrokerageAuthTab } from 'services/ExternalAuthorizationURLBuilder';
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';
import InterceptMessageModal from '../Modal/InterceptMessageModal';
import { EXIT_MODAL_VIEW_COUNT } from 'services/Products';
import {isBrkInterceptMsgEnabled} from 'services/FeatureFlags';

const Link = ({ className, accountId, accountName, handleModalOpen }) => {
  if(isBrkInterceptMsgEnabled()) {
    return <a
      className={classNames('app-link', className)}
      id={`account-name-link-${accountId}`}
      target="_blank"
      onClick={handleModalOpen}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          const link = document.getElementById(`account-name-link-${accountId}`);
          if (link) {
            link.click();
          }
        }
      }}
      tabIndex="0">
      <span className="link-text inline-link-external">{accountName}</span>
    </a>
  } else {
    return <a
      className={classNames('app-link', className)}
      id={`account-name-link-${accountId}`}
      target="_blank"
      onClick={() => openBrokerageAuthTab(accountId)}
      onKeyDown={(e) => {
        if(e.key === 'Enter') {
          const link = document.getElementById(`account-name-link-${accountId}`)
          if(link) {
            link.click();
          }
        }
      }}
      tabIndex="0"
    >
      <span className="link-text inline-link-external">{accountName}</span>
    </a>
  }
};

const BrokerageLinkWithPermissions = WithUserPermissions(Link);

const BrokerageLink = ({
  accountId,
  accountName,
  className = '',
  isHolding = false
}) => {
  const [hasResponsebrkIntercept, setHasResponsebrkIntercept] = useState(true);
  const handleModalOpen = () => {
    const openedCount = Number(localStorage.getItem(EXIT_MODAL_VIEW_COUNT)) || 0;
    if (openedCount >= 3 || !hasResponsebrkIntercept) {
      openBrokerageAuthTab(accountId);
    } else {
      const newOpenCount = openedCount + 1;
      localStorage.setItem(EXIT_MODAL_VIEW_COUNT, newOpenCount)
      const modal = document.getElementById('account-selection-modal');
      if (modal !== null) {
        modal.show();
      }
    }
  };
  return (
    <>
      {isHolding ? (
        accountName
      ) : (
        <BrokerageLinkWithPermissions
          className={className}
          accountId={accountId}
          accountName={accountName}
          handleModalOpen={handleModalOpen}
          shouldDisable
        />
      )}
      <InterceptMessageModal
        setHasResponsebrkIntercept={setHasResponsebrkIntercept}
        openBrokerageAuthTab={() => openBrokerageAuthTab(accountId)}
      />
    </>
  );

      };

BrokerageLink.propTypes = {
  accountId: PropTypes.string,
  accountName: PropTypes.string,
  className: PropTypes.string,
  isHolding: PropTypes.bool
};

export default BrokerageLink;
